<h2>{{ 'register.manualFlow.modals.editLanguage' | translate }}</h2>

<form [formGroup]="languageForm" class="field-grid">
    <div class="field">
        <label for="editlanguage">{{ 'register.manualFlow.step4.language' | translate }}</label>
        <select class="otherInput" id="editlanguage" formControlName="language" [compareWith]="sameValue">
            <option [ngValue]="''" disabled>{{ 'register.manualFlow.step4.select' | translate }}</option>
            <option *ngFor="let language of languages" [ngValue]="language">{{ 'register.step4.languages.languagesList.' + language.name | translate }}</option>
        </select>
        <p class="error-message" *ngIf="languageForm.get('language')?.invalid && languageForm.get('language')?.touched">{{ 'register.manualFlow.errors.required' | translate }}</p>
    </div>
    <div class="field">
        <label for="editlanguageLevel">{{ 'register.manualFlow.step4.level' | translate }}</label>
        <select class="otherInput" id="editlanguageLevel" formControlName="languageLevel" [compareWith]="sameValue">
            <option [ngValue]="''" disabled>{{ 'register.manualFlow.step4.select' | translate }}</option>
            <option *ngFor="let level of languageLevels" [ngValue]="level">{{ 'register.step4.selectLevelNames.' + level.level | translate }}</option>
        </select>
        <p class="error-message" *ngIf="languageForm.get('languageLevel')?.invalid && languageForm.get('languageLevel')?.touched">{{ 'register.manualFlow.errors.required' | translate }}</p>
    </div>
</form>

<div class="modal-actions">
    <button type="button" class="text-button" (click)="close()">{{ 'register.manualFlow.modals.cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="saveEditLanguage()">{{ 'register.manualFlow.modals.save' | translate }}</button>
</div>
